export default __webpack_public_path__ + "static/media/vuesax-linear-eye-slash.cfa5747f.svg";